<template>
  <div class="krathong" >
    <div class="krathong-item" :style="{ animationDuration: duration + 's',top:topItem+'px',zIndex:KrathongZ }">
      <img :src="imageUrl" alt="Krathong Image" class="krathong-image" :style="getStyle(heightSize)"  />
      <div class="krathong-caption">{{ caption }}</div>
    </div>
  </div>
</template>

<script>


export default {
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      default: 'Loy Krathong Item',
    },
    duration: {
      type: Number,
      required: true,  // Mark as required to ensure it's always passed from the parent
    },
    topItem:{
      type:String,
      required: true,
    },
    heightSize:{
      type:Number,
      required:true
    },
    KrathongZ:{
      type:Number,
      required:true
    },
    // styTop:{
    //   type:Number,
    //   required:true
    // }
    // index:{
    //   type:Number,
    //   required:true
    // }
  },
  data(){
    return{
      sizeRandom:[100,150,200],
      bottomNum: [200,400,500,70],
    }
  },
  methods:{
    getStyle(height) {
      // const chosenNumber = Math.floor(Math.random() * this.sizeRandom.length);
      // const randomSize =  this.sizeRandom[chosenNumber];
      // const rBottom = Math.floor(Math.random() * this.bottomNum.length);
      // const randomBottom = this.bottomNum[rBottom];
      // const randomTop = Math.random() * 100; // example for generating a random top value
      // const randomZindex = Math.floor(Math.random() * 10); // example for random z-index
      // const randomSpeed = Math.random() * 5 + 2; // example for random animation speed

      return {
        width:`auto`,
        height:`${height}px`,
    
       
        // top: `-${randomBottom}px`,
        // zIndex: randomZindex, // camelCase instead of z-index
        // animationDelay: `${index * 2}s`, // staggered start
        // animationDuration: `${randomSpeed}s`, // random speed
      };
    },
  }
};
</script>
<!-- display: flex; -->
<style lang="scss" scoped>
.krathong{
 

 /* position: relative;
  width: 100vh;
  height: auto;
  overflow: hidden;
   bottom: 1px;
 top: 400px;*/
}
.krathong-item {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  /*width: 120px;*/
  text-align: center;
  animation: moveLeftToRight linear infinite;
 
}

.krathong-item img {
  width: 100px;
  height: auto;
  border-radius: 50%;
 /* animation: sway 2s ease-in-out infinite; */
 animation: balloon_text 4s ease-in-out infinite;
 
}

.krathong-caption {
 /* margin-top: 8px;
  font-size: 1rem;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 5px;
  border-radius: 5px;*/
  text-align: center;
  border-radius: 30px;
  padding: 5px 10px;
  font-size: 0.9rem;
 
  background-color: rgba(255, 255, 255, 0.637);
  position: absolute;
  bottom: 1;
  left: -20px;
  box-sizing: border-box;
  color: #000000;
  animation: balloon_text 4s ease-in-out infinite;
}

/* Keyframes for the left-to-right animation */
@keyframes moveLeftToRight {
 
 0% {
    transform: translateX(-150px);
  }
  100% {
    transform: translateX(100vw);
  }
}
@keyframes sway {
  0% {
    transform: translateX(0) rotate(0deg);
  }
  25% {
    transform: translateX(5px) rotate(3deg);  /* Move to the right slightly */
  }
  50% {
    transform: translateX(0) rotate(0deg);    /* Return to neutral position */
  }
  75% {
    transform: translateX(-5px) rotate(-3deg); /* Move to the left slightly */
  }
  100% {
    transform: translateX(0) rotate(0deg);    /* Return to neutral position */
  }
}


@-moz-keyframes balloon_text {
  0%, 100% {
    -webkit-transform: translateY(0) rotate(-2deg);
  }

  50% {
    -webkit-transform: translateY(-25px) rotate(1deg);
  }
}
@-webkit-keyframes balloon_text {
  0%, 100% {
    -webkit-transform: translateY(0) rotate(-2deg);
  }

  50% {
    -webkit-transform: translateY(-25px) rotate(1deg);
  }
}
@-o-keyframes balloon_text {
  0%, 100% {
    -webkit-transform: translateY(0) rotate(-2deg);
  }

  50% {
    -webkit-transform: translateY(-25px) rotate(1deg);
  }
}
@-ms-keyframes balloon_text {
  0%, 100% {
    -webkit-transform: translateY(0) rotate(-2deg);
  }

  50% {
    -webkit-transform: translateY(-25px) rotate(1deg);
  }
}
@keyframes balloon_text {
  0%, 100% {
    -webkit-transform: translateY(0) rotate(-2deg);
  }

  50% {
    -webkit-transform: translateY(-25px) rotate(1deg);
  }
}
</style>
